















import { Vue, Component } from 'vue-property-decorator';
import AsignacionPantalla from '@/pantallas/AsignacionMultiFlota/AsignacionPantalla.vue';

@Component({
  components: { AsignacionPantalla },
})
export default class AsignacionIndex extends Vue {}
